import { isTablet, isMobile } from 'react-device-detect';

import SliderIndicatorDefault from './SliderIndicatorDefault';
import SliderIndicatorMobile from './SliderIndicatorMobile';

const SliderIndicator = !isTablet && isMobile ? SliderIndicatorMobile : SliderIndicatorDefault;

export default SliderIndicator;

